import React from 'react'

const labelStyle = { fontSize: 11, letterSpacing: 0.5, textTransform: "uppercase", color: "#6c757d" };
const valueStyle = { fontSize: 14, fontWeight: 600, wordBreak: "break-word" };

// Read-only label/value grid used by the "View" popups
// fields: [{ label, value, badge? }]
const DetailView = ({ fields }) => (
  <div className="row g-3">
    {fields.map((f) => {
      const empty = f.value === undefined || f.value === null || f.value === "";
      const active = String(f.value).toLowerCase() === "active";
      return (
        <div className="col-md-6" key={f.label}>
          <div style={labelStyle}>{f.label}</div>
          {f.badge && !empty ? (
            <span style={{
              display: "inline-block", fontSize: 12, fontWeight: 600, padding: "2px 10px", borderRadius: 12,
              background: active ? "#e6f7f1" : "#fdecec", color: active ? "#0f8a5f" : "#d64545",
              textTransform: "capitalize",
            }}>{f.value}</span>
          ) : (
            <div style={valueStyle}>{empty ? "-" : f.value}</div>
          )}
        </div>
      );
    })}
  </div>
);

export default DetailView;
